import { Children } from 'react';
import classNames from 'classnames';

import Card from '../Card';

import styles from './_index.module.scss';

export interface TopicLibraryCardProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  actions?: React.ReactNode[];
  children?: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
  icon?: React.ReactNode;
  isActive?: boolean;
  isFooterAlwaysVisible?: boolean;
  tabIndex?: number;
  title?: React.ReactNode;
  titleAccessory?: React.ReactNode;
  variant?: 'dark' | 'light';
}

const TopicLibraryCard = ({
  actions = [],
  children = null,
  className = '',
  footer = null,
  icon = null,
  isActive = false,
  isFooterAlwaysVisible = false,
  tabIndex = 0,
  title = null,
  titleAccessory = null,
  variant = 'light',
  ...rest
}: TopicLibraryCardProps) => {
  const hasTitleRow = Boolean(title || titleAccessory);

  return (
    <Card
      className={classNames(
        styles['topic-library-card'],
        {
          [styles['variant-dark']]: variant === 'dark',
        },
        {
          [styles['is-active']]: isActive,
          [styles['is-footer-always-visible']]: isFooterAlwaysVisible,
        },
        className
      )}
      padding="small"
      tabIndex={tabIndex}
      {...rest}
    >
      {icon && <div className={styles['topic-library-card-icon']}>{icon}</div>}

      <div className={styles['topic-library-card-right']}>
        <div className={styles['topic-library-card-content']}>
          <div className={styles['topic-library-card-body']}>
            {hasTitleRow && (
              <div className={styles['topic-library-card-header']}>
                {title ? (
                  <div className={styles['topic-library-card-title']}>{title}</div>
                ) : (
                  <span />
                )}
                {titleAccessory && (
                  <div className={styles['topic-library-card-actions']}>{titleAccessory}</div>
                )}
              </div>
            )}
            {children}
          </div>

          {actions.length > 0 && (
            <div className={styles['topic-library-card-actions']}>{Children.toArray(actions)}</div>
          )}
        </div>

        {footer && <div className={styles['topic-library-card-divider']} />}

        {footer && <div className={styles['topic-library-card-footer']}>{footer}</div>}
      </div>
    </Card>
  );
};

export default TopicLibraryCard;
